import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "assets";
import { Loader } from "components";
import { SNACKBAR_AUTO_HIDE_MS } from "config/constants";
import { SnackbarProvider } from "notistack";
import Routing from "./routing/Routing";

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
}

export const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <SnackbarProvider
        autoHideDuration={SNACKBAR_AUTO_HIDE_MS}
        maxSnack={3}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Loader />
        <Routing />
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
